export const environment = {
	production: false,
	maintenance: false,
	phpServer: "http://localhost:8080"
};
